import React, { useEffect } from 'react';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div id="page_container">
      <div className="padding-right-60 padding-left-60 content-wrap">
        <h1 className="padding-bottom-50 margin-top-10">Our mission is to improve disaster animal response capabilities worldwide.</h1>
        <p>
          We accomplish this mission through government consultation for legislative change and
          development of an intuitive communications and mapping platform based on stakeholder
          engagement.
        </p>

        <p>
          Our platform was created to align with the UN General Assembly endorsed Sendai
          Framework for Disaster Risk Reduction which aims for the following outcome:
        </p>

        <p>
          <i>
            The substantial reduction of disaster risk and losses in lives, livelihoods and
            health and
            in the economic, physical, social, cultural and environmental assets of persons,
            businesses, communities and countries.
          </i>
        </p>

        <p>
          When a disaster strikes, be it a natural disaster or man-made, evacuation orders may
          be declared. In the event of a sudden evacuation, animals may unwillingly be
          left behind. Evidence has shown that many pet owners have either dismissed
          evacuation orders or re-entered evacuated communities in order to
          save their pets. As a result, emergency responders enter dangerous areas to rescue pets
          and pet owners, putting more strain on an already taxed evacuation response.
        </p>

        <p>
          Disaster Pets communications and mapping system was designed to organize
          disaster response in order to allow for clear communication and
          collaboration amongst stakeholders, improving safety of responders and
          reducing lives lost to disasters.
        </p>

        <p>
          The Disaster Pets communications and mapping system allows you to:
        </p>
        <ul>
          <li>
            Keep the details of evacuation requests, lost pets, and found pets organized and
            accessible within one centralized platform.
          </li>
          <li>
            Plan safe evacuation response with dynamic mapping and detailed information
            spreadsheets.
          </li>
          <li>
            Communicate real time status and location of pets with government, animal response
            organizations, and pet owners.
          </li>
          <li>Manage response efficiently between various organizations.</li>
          <li>Save valuable time and resources by reducing redundancies in rescue attempts.</li>
          <li>
            Easily track pets from rescue request to sheltering to veterinary care to reunification
            with unique auto-generated Disaster Pets Identification #&apos;s.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default About;
